module.exports = __webpack_public_path__ + "img/icons8-microsoft-powerpoint-2019.7649d332.svg";